import Axios from "@/store/api";

export const fetchLastOrders = async () => {
  try {
    const res = await Axios.get(`/orders`, {
      params: {
        page: 0,
        size: 10,
        sort: "createTime,desc",
      },
    });

    return res.data.content;
  } catch (error) {
    throw error;
  }
};

export const fetchLastCardsOrders = async () => {
  try {
    const res = await Axios.get(`/orders`, {
      params: {
        page: 0,
        size: 10,
        sort: "createTime,desc",
        filterBy: "cards",
      },
    });

    return res.data.content;
  } catch (error) {
    throw error;
  }
};

export const fetchAllOrders = async (page, size, filterBy) => {
  try {
    const res = await Axios.get(
      "/orders" + (filterBy !== "all" ? `?filterBy=${filterBy}` : ""),
      {
        params: {
          page,
          size,
          sort: "createTime,desc",
        },
      }
    );

    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchOrdersByPhone = async phoneNumber => {
  const params = { phoneNumber };
  const res = await Axios.get(`/orders/search`, { params });
  return res.data;
};

export const activateCard = async (id, number) => {
  const res = await Axios.post(
    `/orders/activationInternet?orderId=${id}&number=${number}`
  );
  return res.data;
};

export const activation = async (id, number) => {
  try {
    const res = await Axios.post(
      `/orders/activation?productId=${id}&playerId=${number}`
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchConsumptions = async (start, end) => {
  const res = await Axios.get(`/orders/consumptions?start=${start}&end=${end}`);
  return res.data;
};

export const fetchAllOrdersOfUser = async (userId, page, size) => {
  const res = await Axios.get(`/users/orders/${userId}`, {
    params: {
      page,
      size,
      sort: "createTime,desc",
    },
  });
  return res.data;
};

export const fetchOrderDetails = async id => {
  const res = await Axios.get(`/client/orderDetails?orderId=${id}`);
  return res.data;
};

export const fetchItemsByOrderId = async (id, page, size) => {
  const res = await Axios.get(`/orders/items?orderId=${id}`, {
    params: { page, size, sort: "code,desc" },
  });
  return res.data;
};

export const checkPhone = async number => {
  const res = await Axios.post(`/orders/checkPhone?number=${number}`);
  return res.data;
};

export const activateCardBySession = async (
  orderId,
  sessionId,
  number,
  subscription
) => {
  const res = await Axios.post(`/orders/activationInternetBySessionId`, {
    orderId,
    sessionId,
    number,
    subscription,
  });

  return res.data;
};

export const deductBalanceToAdmin = async (userId, orderId) => {
  const res = await Axios.post(`/transactions/deductToAdmin/${userId}`, { orderId });
  return res.data;
};
